module.exports = __webpack_public_path__ + "img/mobilesystem2.8a4630be.png";